import React from 'react';
import { Content, PageWithHeader } from '@backstage/core-components';
import CustomApiExplorer from './CustomApiExplorer';

const CatalogApiDocs = () => {
  return (
    <PageWithHeader
      themeId="apis"
      title="APIs"
      subtitle="APIs page provides a preview for APIs with endpoints test capabilities if configured, documentation is available per API."
    >
      <Content>
        <CustomApiExplorer />
      </Content>
    </PageWithHeader>
  );
};

export default CatalogApiDocs;
